import { render } from "./ModalAddDocument.vue?vue&type=template&id=617dde73&scoped=true"
import script from "./ModalAddDocument.vue?vue&type=script&lang=js"
export * from "./ModalAddDocument.vue?vue&type=script&lang=js"

import "./ModalAddDocument.vue?vue&type=style&index=0&id=617dde73&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-617dde73"]])

export default __exports__